import { ApiMetaDataDTO } from 'declarations'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

type ResponseDTO = {
  code: number
  data: number[]
  api_metadata: ApiMetaDataDTO
}

export const usePartNumberRulesSequencesQuery = (): UseQueryResult<
  number[],
  unknown
> => {
  return useQuery({
    queryKey: ['part-number-rules', 'sequences'],
    queryFn: async () => {
      try {
        const res = await client.get<ResponseDTO>(
          '/part_number_rules/sequence/list'
        )
        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
}
